export default "__VITE_ASSET__CVHISh3Z__"